import { ContentBlock } from "./contentBlock";
import { ImageAsset } from "./imageAsset";

export type ImageTextCollage = {
    id: string;
    _type: 'imageTextCollage';
    slides: {
        images?: {
            image?: ImageAsset;
            format?: 'landscape' | 'portrait';
            position?: '0px' | '64px' | '128px' | '256px';
        }[];
        mobileImages?: {
            image?: ImageAsset;
        }[];
        slideTitle: string;
        tapText?: string;
    }[];
}

export const isImageTextCollage = (solution: ContentBlock): solution is ImageTextCollage => {
    return solution._type === 'imageTextCollage';
}